import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import {
  Autocomplete,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";
import { useClaimAttachmentActions } from "../../hooks/useClaimAttachmentActions.jsx";

function AttachmentUsedInModal({ open, onClose, attachment, schadenId }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const { updateClaimAttachment } = useClaimAttachmentActions();

  useEffect(() => {
    if (!open) return;

    setTags(attachment?.used_in ?? []);

    if (schadenId) {
      backendGet(`data/anlages/used-in-tags?schaden_id=${schadenId}`, {
        setIsLoading: () => {},
        setResult: (res) => setSuggestions(res?.data ?? []),
      });
    }
  }, [open, attachment?.id, schadenId]);

  const handleSave = async () => {
    await updateClaimAttachment(
      { id: attachment?.id, used_in: tags },
      {
        setIsLoading,
        onSuccess: () => {
          enqueueSnackbar("Kategorien aktualisiert", { variant: "success" });
          onClose();
        },
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Kategorien bearbeiten</DialogTitle>
      <DialogContent sx={{ pt: "16px !important" }}>
        <Autocomplete
          multiple
          freeSolo
          options={suggestions}
          value={tags}
          onChange={(_, newValue) => setTags(newValue)}
          renderValue={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option}
                label={option}
                size="small"
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kategorien"
              placeholder="Kategorie eingeben…"
              helperText="Enter drücken um eine neue Kategorie hinzuzufügen"
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="tertiary" onClick={onClose} disabled={isLoading}>
          Abbrechen
        </Button>
        <Button onClick={handleSave} loading={isLoading}>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AttachmentUsedInModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    used_in: PropTypes.arrayOf(PropTypes.string),
  }),
  schadenId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default AttachmentUsedInModal;
